import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=5f90c64b&scoped=true&"
import script from "./productInfo.vue?vue&type=script&lang=js&"
export * from "./productInfo.vue?vue&type=script&lang=js&"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=5f90c64b&lang=scss&scoped=true&"
import style1 from "./productInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90c64b",
  null
  
)

export default component.exports